import { useInfiniteQuery } from '@tanstack/react-query';

import type { GetAdminV1StoresStoreIdInventoryMovementsParams } from '@nucleus-commerce/api-client/admin';

import { inventoryApi } from '../api/inventory-api';

import { inventoryKeys } from './inventory-keys';

/** The ledger of one variant at one location, newest first, loaded a page at a time. */
export function useInventoryMovements(
  storeId: string,
  params: Omit<GetAdminV1StoresStoreIdInventoryMovementsParams, 'cursor'>,
  enabled = true,
) {
  return useInfiniteQuery({
    queryKey: inventoryKeys.movementList(storeId, params),
    queryFn: ({ pageParam }) =>
      inventoryApi.movements(storeId, pageParam ? { ...params, cursor: pageParam } : params),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (page) => page.nextCursor ?? undefined,
    enabled,
  });
}
